import * as MutationTypes from './mutation-types'
import { underLoadingFunction } from '@/store/helpers/under-loading'
import PrintService from '@/services/print-service'
import { NotAuthenticatedError } from '../../models/not-authenticated-error'

export default {
  state: {
    printAction: null,
    patientPrintDocs: null
  },

  getters: {
    getPrintButtonAction: (state) => state.printAction,
    getPatientPrintDocs: (state) => state.patientPrintDocs
  },

  mutations: {
    setPrintAction(state, action) {
      state.printAction = action
    },
    [MutationTypes.GET_PATIENT_PRINTED_DOCS](state, payload) {
      state.patientPrintDocs = payload
    }
  },

  actions: {
    registerPrintAction({ commit }, action) {
      commit('setPrintAction', action)
    },
    async obterPdfDocumento({ commit }, payload) {
      commit('setLoadingState', true)
      await PrintService.obterPdfDocumento({ ...payload })
        .then((res) => {
          if (!res.ok && res.status !== 200) {
            if (res.status === 401) throw new NotAuthenticatedError()
            throw new Error(`HTTP error, status ${res.status}`)
          }
          return res.data
        })
        .then((data) => {
          commit(MutationTypes.GET_PATIENT_PRINTED_DOCS, data)
          commit('setLoadingState', false)
        })
        .catch((err) => {
          throw err
        })
    },
    async obterDocumento({ commit }, payload) {
      commit('setLoadingState', true)
      await PrintService.obterDocumento({ ...payload })
        .then((res) => {
          if (!res.ok && res.status !== 200) {
            if (res.status === 401) throw new NotAuthenticatedError()
            throw new Error(`HTTP error, status ${res.status}`)
          }
          return res.data
        })
        .then((data) => {
          commit(MutationTypes.GET_PATIENT_PRINTED_DOCS, data)
          commit('setLoadingState', false)
        })
        .catch((err) => {
          throw err
        })
    },
    obterPdfAtestado: underLoadingFunction(async ({ commit }, payload) => {
      const response = await PrintService.obterPdfAtestado({ ...payload })
      commit(MutationTypes.GET_PATIENT_PRINTED_DOCS, response.data)
    }),
    setPatientAllPrintTests: underLoadingFunction(
      async ({ commit }, payload) => {
        const response = await PrintService.getPrintAllDocs({ ...payload })
        commit(MutationTypes.GET_PATIENT_PRINTED_DOCS, response.data)
      }
    )
  }
}
